import React from 'react';
import IEmptyProps from "EmptyProps";
import TextField from 'CommonControls/TextField';
import { ButtonStyle } from 'CommonControls/ButtonStyle';
import Button from 'CommonControls/Button';
import BeerService from 'Services/BeerService';
import { dicontainer } from 'DIContainer';
import Alert, { AlertType } from 'CommonControls/Alert';
import PageNavigationController from 'PageNavigation/PageNavigationController';

interface IPriceUnlockModalState {
    isInvalidCode?: boolean;
    accessCode?: string;
}

export default class PriceUnlockModal extends React.Component<IEmptyProps, IPriceUnlockModalState> {
    private _beerService: BeerService = dicontainer.get(BeerService);
    private _pageNavigationController: PageNavigationController = dicontainer.get(PageNavigationController);

    constructor(props: IEmptyProps) {
        super(props);
        this.state = {
            accessCode: localStorage.getItem("beerPricingAccessCode") ?? undefined,
            isInvalidCode: false
        }
        this.handleContactClick = this.handleContactClick.bind(this);
        this.handleTextChanged = this.handleTextChanged.bind(this);
        this.handleValidate = this.handleValidate.bind(this);
        this.handleValidateFailure = this.handleValidateFailure.bind(this);
        this.handleValidateSuccess = this.handleValidateSuccess.bind(this);
    }

    private handleContactClick() {
        this._pageNavigationController.switch("accueil", "nous-joindre");
    }

    private handleTextChanged(sender: TextField, text?: string) {
        this.setState({ accessCode: text });
    }

    private handleValidate() {
        this._beerService.tryUnlockPricing(this.state.accessCode!, this.handleValidateSuccess, this.handleValidateFailure);
    }

    private handleValidateFailure() {
        this.setState({
            isInvalidCode: true
        });
    }

    private handleValidateSuccess() {
        localStorage.setItem("beerPricingAccessCode", this.state.accessCode!);
        this._pageNavigationController.closeModal();
    }

    public render() {
        return (
            <div className="price-unlock-modal content">
                {this.state.isInvalidCode &&
                    <Alert type={AlertType.Danger}>Code d'accès invalide. Veuillez réessayer.</Alert>
                }
                <p>Nos prix sont divulgués sur demande afin de respecter la confidentialité de notre entente avec Labatt. Distribution aux associations étudiantes de l'Université Laval uniquement. Veuillez <a href="#" className="color-inherit" onClick={this.handleContactClick}>nous contacter</a> pour obtenir votre code d'accès.</p>
                <div className="form-entry">
                    <TextField placeholderText="Code d'accès" text={this.state.accessCode} onTextChanged={this.handleTextChanged} />
                    <Button style={ButtonStyle.StandardPrimary} text="Valider" onClick={this.handleValidate} />
                </div >
            </div>
        );
    }
}